var map = {
	"./1-0.webp": "a6eb",
	"./1-1.webp": "bddb",
	"./1-2.webp": "c6a1",
	"./1-3.webp": "733e",
	"./1-4.webp": "6969",
	"./1-5.webp": "3e48",
	"./1-6.webp": "913b",
	"./2-types-articles.webp": "91b4",
	"./diesel-generators.webp": "9b29",
	"./energy-use.webp": "e0b4",
	"./geo-map.webp": "3feb",
	"./github.webp": "526f",
	"./hydro-map.webp": "7bab",
	"./inst.mp4": "ca21",
	"./instagram.webp": "97e8",
	"./pellet-map.webp": "6247",
	"./renouvelables-explained.webp": "69da",
	"./sun-map.webp": "627b",
	"./team-design.webp": "626e",
	"./team-dev.webp": "cdf6",
	"./team-market.webp": "bdc1",
	"./telegram.webp": "db39",
	"./vk.webp": "b50c",
	"./wave-map.webp": "eed3",
	"./wind-map.webp": "ec88"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";